import { prefixObjectValues } from '../utils';

const addLayout = {
  grid: 'grid',
  card: 'card',
  addMultiBtn: 'all-multi-btn',
  addBtn: 'add-btn',
  addNewBtn: 'add-new-btn',
  cancelBtn: 'cancel-btn',
  specialtyFilter: 'specialty-filter',
};

export default prefixObjectValues(addLayout, 'add-privileges-layout');
